import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity, Wifi } from 'lucide-react';
import { getRealtimeMetrics } from '@/data/mockData';

export const RealtimeMetrics: React.FC = () => {
  const [metrics, setMetrics] = useState(getRealtimeMetrics());
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    // Simulate real-time updates every 5 seconds
    const interval = setInterval(() => {
      setMetrics(getRealtimeMetrics());
    }, 5000);

    // Simulate connection status
    const connectionInterval = setInterval(() => {
      setIsConnected(Math.random() > 0.1); // 90% uptime simulation
    }, 10000);

    return () => {
      clearInterval(interval);
      clearInterval(connectionInterval);
    };
  }, []);

  return (
    <Card className="animate-fade-in-up transition-smooth hover:shadow-elegant animate-pulse-glow">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Activity className="h-5 w-5 text-blue-600" />
            <CardTitle className="text-lg font-semibold">Métricas em Tempo Real</CardTitle>
          </div>
          <div className="flex items-center space-x-2">
            <Wifi className={`h-4 w-4 ${isConnected ? 'text-green-600' : 'text-red-600'}`} />
            <Badge 
              variant={isConnected ? "default" : "destructive"}
              className={`text-xs ${isConnected ? 'bg-green-100 text-green-800 hover:bg-green-100' : ''}`}
            >
              {isConnected ? 'Conectado' : 'Desconectado'}
            </Badge>
          </div>
        </div>
        <CardDescription>
          Última atualização: {metrics.lastUpdated}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg">
            <div className="text-2xl font-bold text-blue-700">
              R$ {metrics.currentRevenue.toLocaleString('pt-BR')}
            </div>
            <div className="text-sm text-blue-600">Receita Hoje</div>
          </div>
          
          <div className="text-center p-4 bg-gradient-to-br from-green-50 to-green-100 rounded-lg">
            <div className="text-2xl font-bold text-green-700">
              {metrics.activeUsers}
            </div>
            <div className="text-sm text-green-600">Usuários Online</div>
          </div>
          
          <div className="text-center p-4 bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg">
            <div className="text-2xl font-bold text-purple-700">
              {metrics.conversionRate}%
            </div>
            <div className="text-sm text-purple-600">Conversão Atual</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};